<template>
  <v-row justify="start" align="start">
    <v-col cols="12" lg="12" md="12" xs="12">
      <v-banner icon="shopping_cart">
        Checkout
        <template v-slot:actions>
          <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </template>
      </v-banner>
    </v-col>

    <v-col cols="12" md="8" sm="12">
      <v-row justify="start" align="start">
        <v-col cols="12" md="4" sm="12" :style="checkoutFormStyle">
          <div
            v-if="
              (showSafePlace ||
                showAdditonalInstructions ||
                showDisclaimerCheckbox) &&
              !showPaymentOptions
            "
            class="title"
          >
            Delivery Information
          </div>
          <div v-if="showPaymentOptions" class="title">Delivery & Payment</div>
        </v-col>
        <v-col cols="12" md="8" sm="12" :style="checkoutFormStyle">
          <v-form
            class="pa-4"
            ref="checkoutForm"
            @submit.prevent
            v-model="checkoutFormIsValid"
          >
            <v-select
              v-if="showPaymentOptions"
              v-model="paymentMethod"
              :items="availableMethods"
              :rules="paymentMehodRules"
              prepend-icon="mdi-credit-card-marker"
              label="Choose Payment Type "
              dense
            ></v-select>
            <v-select
              v-if="showSafePlace"
              v-model="safePlace"
              :items="safePlaces"
              :rules="safePlaceRules"
              prepend-icon="lock"
              label="Safe Place"
              :class="{ 'pt-4': showPaymentOptions }"
              dense
            ></v-select>
            <v-textarea
              v-if="showAdditonalInstructions"
              v-model="additionalInstructions"
              class="pt-4"
              clearable
              label="Additional Instructions"
              type="text"
              filled
              auto-grow
              rows="3"
              placeholder="If you are self isolating please specify"
              counter
              maxlength="200"
            ></v-textarea>
            <v-checkbox
              v-if="showDisclaimerCheckbox"
              v-model="disclaimerCheckbox"
              :rules="disclaimerCheckboxRules"
              label="I accept the disclaimer"
              color="blue darken-2"
            >

              <template v-slot:label>
                I accept the
                <v-btn
                  class= "pa-0"
                  color="blue darken-2"
                  href="#"
                  text
                  @click.stop.prevent="disclaimerDialog = true"
                  >&nbsp;Disclaimer</v-btn
                >
              </template>
            </v-checkbox>
            <v-checkbox
              v-if="showNote"
              v-model="ageCheckbox"
              :rules="ageCheckboxRules"
              label="I am 18+ years"
              color="blue darken-2"
            >
              <!-- <template v-slot:append v-if="showChallenge25">
              <v-img :src="require('@/assets/challenge25/under25.png')" contain height="180" />
            </template>   -->
            </v-checkbox>
          </v-form>
        </v-col>

        <v-col cols="12" md="4" sm="12" v-if="showNote">
          <div class="title">Note</div>
        </v-col>
        <v-col cols="12" md="8" sm="12" v-if="showNote">
          <age-restricted-product />
        </v-col>
<!-- 
        // IF show_prices = 1 or Unset then show prices
    // - ELSE IF show_prices = 0 then hide prices on the front end
    // - ELSE IF show_prices = 2 then hide prices for anonymous users only -->
        <v-col cols="12" md="4" sm="12">
          <div class="title" v-if="showCncAddress">Collection Order</div>
          <div class="title" v-else>Deliver To</div>
        </v-col>
        <v-col cols="12" md="8" sm="12">
          <CncAddress v-if="showCncAddress" class="mb-4" />

          <SelectedAddress
            v-else-if="
              $store.getters.retrieveIsCashCustomer &&
              $store.getters.retrieveSelectedAddress
            "
            class="mb-4"
            :showSelectAddress="false"
            :outlined="true"
          />
          <CustomerAddress v-else />
        </v-col>

        <v-col cols="12" md="12" sm="12" class="hidden-sm-and-down">
          <v-btn
            :loading="purchaseOrderLoading"
            color="blue darken-2"
            class="white--text"
            @click="purchaseOrder()"
            :disabled="!checkoutFormIsValid"
            >{{ purchaseButtonText }}</v-btn
          >
        </v-col>

        <v-dialog
          v-model="disclaimerDialog"
          absolute
          max-width="400"
          persistent
        >
          <v-card>
            <v-toolbar color="background" flat dense>
              <v-toolbar-title>Disclaimer</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="disclaimerDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>{{ disclaimerContent }}</v-card-text>
            <v-card-actions>
              <v-btn
                text
                @click="
                  (disclaimerCheckbox = false), (disclaimerDialog = false)
                "
                >Cancel</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="blue darken-2"
                @click="(disclaimerCheckbox = true), (disclaimerDialog = false)"
                >Accept</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-col>
    <v-col cols="12" md="4" sm="12">
      <v-btn
        :loading="purchaseOrderLoading"
        block
        :disabled="!checkoutFormIsValid"
        color="blue darken-2"
        class="white--text"
        @click="purchaseOrder()"
        >{{ purchaseButtonText }}</v-btn
      >

      <v-card class="mt-4" outlined>
        <v-card-title>Order Summary</v-card-title>
        <v-card-text>
          Order for:
          <b>{{ orderDate }}</b>
        </v-card-text>
        <v-card-text>
          No. Items:
          <b>{{ totalBasketItems }}</b>
        </v-card-text>
        <v-card-text>
          Total Quantity:
          <b>{{ totalQty }}</b>
        </v-card-text>

        <!-- $store.getters.retrieveShowPrices this calls the function to see if it was true, if true  shows total amount  
           if false hides the total
        -->
        <v-card-text v-if="$store.getters.retrieveShowPrices">
          <div class="mb-2">
            Net Total:
            <b
              >£{{
                parseFloat(
                  $store.getters.retrieveCurrentTrolly.trolly_value_minus_vat
                ).toFixed(2)
              }}</b
            >
            <br />
            VAT:
            <b
              >£{{
                parseFloat(
                  $store.getters.retrieveCurrentTrolly.trolly_vat
                ).toFixed(2)
              }}</b
            >

            <br />

            <div
              v-if="
                $store.getters.retrieveCurrentTrollyDiscountEnabled &&
                $store.getters.retrieveCurrentTrolly.order_discount.discount_id
              "
            >
              Discount Amount:
              <b>
                -£{{
                  parseFloat(
                    $store.getters.retrieveCurrentTrollyDiscountAmount
                  ).toFixed(2)
                }}
              </b>
              <br />
            </div>

            <div
              v-if="
                $store.getters.retrieveCurrentTrollyDiscountEnabled &&
                $store.getters.retrieveCurrentTrolly.order_discount.discount_id
              "
            >
              Discount VAT Reduction:
              <b>
                -£{{
                  parseFloat(
                    $store.getters.retrieveCurrentTrollyDiscountVAT
                  ).toFixed(2)
                }}
              </b>
            </div>
          </div>

          <div class="pt-2 borderTop">
            Grand Total:<b>
              £{{
                parseFloat(
                  this.$store.getters.retrieveCurrentTrolly.grand_total
                ).toFixed(2)
              }}
            </b>
          </div>
        </v-card-text>
      </v-card>
      <v-img
        :src="require('@/assets/challenge25/under25.png')"
        contain
        height="180"
        v-if="showChallenge25"
      />
    </v-col>
  </v-row>
</template>

<script>
import CncAddress from "@/components/order/CncAddress.vue";
import CustomerAddress from "@/components/customer/CustomerAddress.vue";
import SelectedAddress from "@/components/deliveryAddresses/SelectedAddress.vue";

import AgeRestrictedProduct from "@/components/order/AgeRestrictedProduct.vue";

import axios from "axios";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CncAddress,
    CustomerAddress,
    SelectedAddress,
    AgeRestrictedProduct,
  },
  data() {
    return {
      additionalInstructions: "",
      //test
      safePlace: null,
      safePlaceRules: [(v) => !!v || "You must choose a safe place"],
      safePlaces: [
        "Front Door",
        "Shed",
        "Back door",
        "Behind Wheelie Bin",
        "With next-door-neighbour",
        "Garden",
        "None of the above",
      ],

      disclaimerDialog: false,
      disclaimerCheckbox: false,
      disclaimerCheckboxRules: [(v) => !!v || "You must accept the disclaimer"],

      purchaseOrderLoading: false,
      checkoutFormIsValid: false,
      ageCheckbox: false,
      ageCheckboxRules: [
        (v) => !!v || "You must be over 18 to complete this order",
      ],
      paymentMethod: null,
      availableMethods: ["Online Card", "Cheque", "Cash", "BACS"],
      paymentMehodRules: [(v) => !!v || "You must chose payment method"],
    };
  },

  activated() {
    if (!this.$store.getters.retrieveCurrentTrolly) {
      this.invalidBasket();
    }
    this.paymentMethod = null;
  },
  computed: {
    ...mapGetters(["retrieveCustomerAddress"]),

    checkoutFormStyle() {
      if (
        this.showSafePlace ||
        this.showAdditonalInstructions ||
        this.showDisclaimerCheckbox
      ) {
        return {};
      } else {
        return {
          padding: 0,
          height: "0px",
        };
      }
    },

    purchaseButtonText() {
      if (
        this.$store.getters.retrieveIsCashCustomer ||
        this.$store.getters.retrieveIsCncCustomer
      ) {
        return "Buy Now";
      } else {
        return "Order Now";
      }
    },

    orderDate() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        return this.$store.getters.retrieveCurrentTrolly.order_date_display;
      } else {
        return null;
      }
    },

    showSafePlace() {
      let showSelector = false;
      let config =
        this.$store.getters.retrieveAllConfigs.orders_delivery_safe_place;

      if (
        config == 1 ||
        (config == 2 && this.$store.getters.retrieveIsCashCustomer)
      ) {
        showSelector = true;
      }

      return showSelector;
    },

    showAdditonalInstructions() {
      let showSelector = false;
      let config =
        this.$store.getters.retrieveAllConfigs
          .orders_delivery_instructions_show;

      if (
        config == 1 ||
        (config == 2 && this.$store.getters.retrieveIsCashCustomer)
      ) {
        showSelector = true;
      }

      return showSelector;
    },

    showDisclaimerCheckbox() {
      let showSelector = false;
      let config =
        this.$store.getters.retrieveAllConfigs
          .orders_create_disclaimer_checkbox;

      if (
        config == 1 ||
        (config == 2 && this.$store.getters.retrieveIsCashCustomer) ||
        (config == 2 && this.$store.getters.retrieveIsCncCustomer)
      ) {
        showSelector = true;
      }

      return showSelector;
    },

    disclaimerContent() {
      let disclaimerContent = "";

      if (
        this.$store.getters.retrieveAllConfigs
          .orders_create_disclaimer_content != ""
      ) {
        disclaimerContent =
          this.$store.getters.retrieveAllConfigs
            .orders_create_disclaimer_content;
      }

      return disclaimerContent;
    },

    totalBasketItems() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
          return Object.keys(
            this.$store.getters.retrieveCurrentTrolly.trolly_items
          ).length;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    totalQty() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        return this.$store.getters.retrieveCurrentTrolly.totalQty;
      } else {
        return 0;
      }
    },

    basketItems() {
      if (this.totalBasketItems) {
        return this.$store.getters.retrieveCurrentTrolly.trolly_items;
      } else {
        return false;
      }
    },

    basketTotal() {
      if (this.totalBasketItems) {
        return this.$store.getters.retrieveCurrentTrolly.totalValue;
      } else {
        return false;
      }
    },
    showCncAddress() {
      if (this.$store.getters.retrieveIsCncCustomer) {
        return true;
      }

      return false;
    },

    showNote() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
          return this.$store.getters.retrieveCurrentTrolly.age_restricted_items
            .hasItems;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showChallenge25() {
      let showChallenge = false;
      if (this.$store.getters.retrieveAllConfigs.show_challenge25) {
        if (
          this.$store.getters.retrieveAllConfigs.show_challenge25 == 1 &&
          this.showNote == true
        ) {
          showChallenge = true;
        }
      }
      return showChallenge;
    },
    showPaymentOptions() {
      if (
        this.$store.state.configs.order_pay_in_cash &&
        (this.$store.getters.retrieveAdmin.account_type == "A1" ||
          this.$store.getters.retrieveAdmin.account_type == "D1") &&
        (this.$store.getters.retrieveSelectedCustomer == "1" ||
          this.$store.getters.retrieveSelectedCustomer == "3" ||
          this.$store.getters.retrieveCustomer.customer.acc_type == "5")
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    ...mapActions(["setSnackbar", "getTrollys", "orderBeingPaidForAction"]),

    async refreshBasket() {
      console.log("-- Close Popups");
      this.editBasketDialog = false;
      this.deleteItemDialog = false;

      console.log("-- Refresh Basket");
      await this.getTrollys()
        .then((response) => {
          console.log("-- Got Trollys");
          console.log(response);
        })
        .catch((er) => {
          console.log(er);
        });
    },

    async purchaseOrder() {
      console.log("-- Checkout");
      console.log(this.disclaimerCheckbox);
      console.log(this.safePlace);

      console.log(this.$refs);
      console.log(this.$refs.checkoutForm);

      if (this.$refs.checkoutForm.validate()) {
        console.log("purchase-order Item");

        if (this.$store.getters.retrieveCurrentTrolly) {
          this.purchaseOrderLoading = true;

          let instructionsString = "";

          if (this.safePlace != null) {
            instructionsString += "Safe Place: ";
            instructionsString += this.safePlace;
          }

          if (this.additionalInstructions != "") {
            if (this.safePlace != null) {
              instructionsString += " - ";
            }
            instructionsString += this.additionalInstructions;
          }
          let payloadObj = {
            sessionKey: this.$store.getters.retrieveUser.sessionKey,
            userId: this.$store.getters.retrieveUser.userNum,
            trollyId: this.$store.getters.retrieveCurrentTrolly.id,
            specialInstructions: instructionsString,
            customerNo: this.$store.getters.retrieveSelectedCustomer,
          };
          if (this.ageCheckbox == true) {
            payloadObj.ageCheck = 1;
          }
          if (
            this.paymentMethod != "null" &&
            this.paymentMethod != "Online Card"
          ) {
            payloadObj.paymentMethod = this.paymentMethod;
          }
          let stringPayload = JSON.stringify(payloadObj);

          const params = new URLSearchParams();
          params.append("params", stringPayload);

          await axios
            .post("purchase-order", params)
            .then((response) => {
              if (response.data.success) {
                this.refreshBasket();

                if (parseInt(response.data.locked)) {
                  const rec = {
                    orderId: response.data.td_id,
                    orderAmount: parseFloat(
                      response.data.orderTotal + response.data.vatTotal
                    ).toFixed(2),
                  };
                  this.orderBeingPaidForAction(rec);
                  this.$router.push({ name: "OrderPayment" });
                } else {
                  this.$router.push({
                    name: "OrdersConfirmation",
                    params: { transaction: response.data },
                  });
                }
              } else {
                console.log("-- Fail :()");
                let errorMessage = "";
                response.data.messages.forEach(function (message) {
                  errorMessage += message + "\n";
                });

                this.setSnackbar({ color: "error", text: errorMessage });
              }
            })
            .catch((err) => {
              console.log(err);
              this.setSnackbar({
                color: "error",
                text: "Error submitting basket",
              });
            });

          this.purchaseOrderLoading = false;
        } else {
          this.invalidBasket();
        }
      }
    },

    invalidBasket() {
      this.setSnackbar({
        color: "error",
        text: "Error: You have no selected basket, if you have already submitted the order please view it on the 'Your Orders' page",
      });

      this.$router.push({ name: "Home" });
    },
  },
};
</script>


<style lang="sass" scoped>
@import '~vuetify/src/styles/styles.sass'

.v-application a
  color: var(--v-blue-darken2)
</style>
